import { normalizeFilter } from './normalize-filter'

export const normalizeLayoutFilter = (rawData) => {
  const { api = '', filter_list: filterList = [] } = rawData
  return {
    api,
    filterList: filterList?.map(normalizeFilter)
  }
}
